<template>
  <div class="rounded-md border border-gray-300 bg-white p-3">
    <slot />
  </div>
</template>
